import * as AgenciesReducer from './agencies';

const Reducers = {
  ...AgenciesReducer,
};

export default Reducers;
